import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { CsIconModule } from '@components/icon';
import {ButtonCtaComponent} from '@components/button-cta/button-cta.component';
import { EventLoggerService } from '@services/event-logger-service';
import { AppConfig } from '../../app.config';

@Component({
  selector: 'active-checkup-bottomsheet',
  standalone: true,
  imports: [CommonModule, CsIconModule, ButtonCtaComponent],
  templateUrl: './active-checkup-bottomsheet.component.html',
})
export class ActiveCheckupBottomsheetComponent implements OnInit {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: {
      userFirstName: string;
      userInitialImagePath?: string;
      daysSinceRegimenDelivery?: number;
      onTakeCheckupNow: () => void;
      onSkip: () => void;
    },
    private readonly bottomSheetRef: MatBottomSheetRef<ActiveCheckupBottomsheetComponent>,
    private readonly eventLogger: EventLoggerService,
    public readonly appConfig: AppConfig,
  ) {}

  ngOnInit(): void {
    this.eventLogger.cleverTapEvent('impression', JSON.stringify({
      name: 'checkup_nudge_back_bottom_sheet',
    }));
  }

  closeBottomSheet(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({
      name: 'checkup_nudge_back_close',
    }));
    this.bottomSheetRef.dismiss('close_button');
  }

  takeCheckupNow(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({
      name: 'checkup_nudge_back_take_checkup',
    }));
    this.bottomSheetRef.dismiss('take_checkup_now');
    this.data.onTakeCheckupNow();
  }

  skip(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({
      name: 'checkup_nudge_back_skip',
    }));
    this.bottomSheetRef.dismiss('skip');
    this.data.onSkip();
  }
}


